<template>
  <article class="trabalhos">
    <Letreiro title="Trabalhos" />
    <section>
      <v-touch class="sessao" @tap="goTo('cinema')" @swipeleft="goTo('cinema')" >
        <h2>
          Cinema
        </h2>
        <p>Nossos projetos cinematográficos contam histórias que buscam maximizar a conexão com o público, explorando formatos consolidados ou as novas linguagens.
          <span class="scroll-right">
            <span class="arrow-right">
            <!-- css generated icon -->
            </span>
          </span>
        </p>
      </v-touch>
      <v-touch class="sessao" @tap="goTo('midias')" @swipeleft="goTo('midias')" >
        <h2>
          Novas Mídias
        </h2>
        <p>A revolução digital trouxe mais velocidade e conectividade ao mundo, nossos projetos em novas mídias investigam formas surpreendentes de contar histórias.
          <span class="scroll-right">
            <span class="arrow-right">
            <!-- css generated icon -->
            </span>
          </span>
        </p>
      </v-touch>
      <v-touch class="sessao" @tap="goTo('producao')" @swipeleft="goTo('producao')" >
        <h2>
          Produção Cultural
        </h2>
        <p>Além de contar histórias e desenvolver tecnologias, buscamos produzir impacto social realizando oficinas, produzindo mostras e criando materiais de difusão artística e política.
          <span class="scroll-right">
            <span class="arrow-right">
            <!-- css generated icon -->
            </span>
          </span>
        </p>
      </v-touch>
    </section>
  </article>
</template>

<script>
import Letreiro from '@/components/Letreiro.vue'

export default {
  name: 'Trabalhos',
  components: {
    Letreiro
  },
  methods: {
    goTo(str) {
      this.$router.push({ name: 'home', params: { path: 'Trabalhos', cat: str } });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2{margin: 0 0 0  2.5%; text-align: left; }
p {margin: 0 0 2.5% 2.5%;}

.trabalhos {transition: all .5s ease-in-out;}
.trigger-cinema .trabalhos ,.trigger-midias .trabalhos ,.trigger-producao .trabalhos {
  margin-left: -100vw;
}
.sessao {cursor: pointer;}
.scroll-right {
  display: inline-block;
  width: auto;
  height: 15px;
  align-items: center;
}
.arrow-right {
  display: inline-block;
  margin: -2px 0 0 -6px;
}
.arrow-right::after {
  content: '';
  display: inline-block;
  margin: auto;
  padding: 0;
  width: 5px;
  height: 5px;
  border-top: 2px solid #77221b;
  border-right: 2px solid #77221b;
  transform: rotate(45deg);
}
.scroll-right::before {
  animation: elasticus 2s cubic-bezier(1, 0, 0, 1) infinite;
  display: inline-block;
  margin-bottom: 2.5px;
  height: 2px;
  width: 20px;
  background: #77221b;
  content: ' ';
}
.sessao:hover h2 {color: #d55349}
.sessao:hover .scroll-right::before {background: #d55349}
.sessao:hover .arrow-right::after {border-color: #d55349}

/* SETA */
@keyframes elasticus {
  0% {
    transform-origin: 0% 0%;
    transform: scale(0, 1);
  }
  50% {
    transform-origin: 0% 0%;
    transform: scale(1, 1);
  }
  50.1% {
    transform-origin: 100% 0%;
    transform: scale(1, 1);
  }
  100% {
    transform-origin: 100% 0%;
    transform: scale(0, 1);
  }
}

/* --- LETREIRO --- */
  .triggerTrabalhos h1 >>> span {
    animation-name: letreiro;
    animation-duration: 1s;
    animation-direction: reverse;
    animation-fill-mode: both;
    opacity: 0;
  }
  /* TRABALHOS */
   h1 >>> span:nth-child(3) { /* a */
    grid-column: 6;
    grid-row: 1;
    animation-delay: 0.6s;
   }
   h1 >>> span:nth-child(4) { /* b */
    grid-column: 1;
    grid-row: 3;
    animation-delay: 0.5s;
   }
   h1 >>> span:nth-child(5) { /* a */
    grid-column: 8;
    grid-row: 5;
    animation-delay: 0.4s;
   }
   h1 >>> span:nth-child(6) { /* l */
    grid-column: 1;
    grid-row: 5;
    animation-delay: 0.3s;
   }
   h1 >>> span:nth-child(7) { /* h */
    grid-column: 1;
    grid-row: 6;
    animation-delay: 0.2s;
   }
   h1 >>> span:nth-child(8) { /* o */
    grid-column: 6;
    grid-row: 8;
    animation-delay: 0.1s;
   }
   h1 >>> span:nth-child(9) { /* s */
    grid-column: 7;
    grid-row: 8;
    animation-delay: 0s;
   }

@media (min-width: 768px) {
/*
  ##Device = Tablets, Ipads
  ##Screen = B/w 768px to 1024px
*/

.trabalhos {display: none;}
/*
.scroll-right::before {background: #d55349}
.arrow-right::after {border-color: #d55349}
.sessao:hover h2 {color: #77221b}
.sessao:hover .scroll-right::before {background: #77221b}
.sessao:hover .arrow-right::after {border-color: #77221b}
*/
/* TRABALHOS */
 h1 >>> span:nth-child(4) { /* b */
  grid-column: 4;
  grid-row: 3;
  animation-delay: 0.5s;
 }
 h1 >>> span:nth-child(5) { /* a */
  grid-column: 8;
  grid-row: 5;
  animation-delay: 0.4s;
 }
 h1 >>> span:nth-child(6) { /* l */
  grid-column: 2;
  grid-row: 6;
  animation-delay: 0.3s;
 }
 h1 >>> span:nth-child(7) { /* h */
  grid-column: 4;
  grid-row: 7;
  animation-delay: 0.2s;
 }
 h1 >>> span:nth-child(8) { /* o */
  grid-column: 6;
  grid-row: 8;
  animation-delay: 0.1s;
 }
 h1 >>> span:nth-child(9) { /* s */
  grid-column: 7;
  grid-row: 8;
  animation-delay: 0s;
 }
}
</style>
